import { render, staticRenderFns } from "./creditwait_form_detail.vue?vue&type=template&id=4ae5c9f7&"
import script from "./creditwait_form_detail.vue?vue&type=script&lang=js&"
export * from "./creditwait_form_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports